import PropTypes from 'prop-types';
import React from 'react';
import DropDownCell from 'components/LineItemTable/dropDownCell';
import InputCell from 'components/LineItemTable/inputCell';
import ItemEvents from 'components/LineItemTable/itemEvents';
import ItemNote from 'components/LineItemTable/itemNote';
import { EditableTableRow, EditableTableCell } from 'components/EditableTable';
import ContractorLineItemShape from 'types/contractorLineItem';
import { calculateTotal, formatDollars, filterByVendor } from '../../../../../../../../utils/lineItemUtils';
import Editable from 'mixins/editable';
import MediaQuery from 'react-responsive';
import S from './laborTables.scss';
import {
  CUT_POINT, ASSESSMENT_LABOR_ITEMS, ADDTL_MILEAGE_ITEMS, ASSESSMENT_DETAIL_ITEMS,
} from 'config/constants';

class ContractorLaborRow extends Editable(React.Component) {
  state = {
    ...this.props.lineItem,
    original_item: this.props.lineItem.item_number || null,
    errors: {},
  };

  handleSave = () => this.props.onSave(this.state);

  handleDelete = () => this.props.onDelete(this.state.id);

  handleChange = attr => (val) => {
    const { fixedTotal = false, fixedPrice = false, price: statePrice, quantity } = this.state;
    const value = val.target ? val.target.value : val;
    const price = attr === 'price' ? value : statePrice;
    const qty = attr === 'quantity' ? value : quantity;
    if (!fixedTotal && !fixedPrice) {
      const total = calculateTotal(price, qty);
      this.setState({ [attr]: value, total });
    } else if (!fixedTotal) {
      const total = calculateTotal(statePrice, qty);
      this.setState({ [attr]: attr === 'price' ? statePrice : value, total });
    } else if (attr === 'note') this.setState({ [attr]: value });
  }

  handleDescriptionChange = (val) => {
    const lineItem = this.state;
    const { lineItemOptions } = this.props;
    const option = lineItemOptions.find(o => o.value === val);
    const { label, price, fixedPrice = false, total: configTotal = null,
            fixedTotal = false } = option;
    const itemNumber = label.split(' ')[0];
    const total = configTotal || calculateTotal(price, lineItem.quantity);
    this.setState({
      line_item_id: val,
      total,
      price,
      item_number: itemNumber,
      fixedPrice,
      fixedTotal,
      quantity: configTotal ? '1' : null,
    });
  }

  getItemNumberFromLabel = ({ label }) => label.substring(0, label.indexOf(' - '));

  filterItemSelection = (options) => {
    const { original_item } = this.state;
    const { phaseType, surfaceType, filterLineItems, phaseSource } = this.props;
    let filteredOptions = options;
    if (filterLineItems) {
      filteredOptions = options.filter(o =>
        !o.surface_type || o.label.includes(original_item) || [surfaceType, 'Multi', 'All'].includes(o.surface_type));
    }
    filteredOptions = filterByVendor(filteredOptions, phaseSource);
    return (phaseType !== 'Assessment' ? filteredOptions :
      filteredOptions.filter(i =>
        ASSESSMENT_LABOR_ITEMS.includes(this.getItemNumberFromLabel(i)) ||
        ADDTL_MILEAGE_ITEMS.includes(this.getItemNumberFromLabel(i)) ||
        ASSESSMENT_DETAIL_ITEMS.includes(this.getItemNumberFromLabel(i)),
      ));
  }

  blockItemCellEdit = (options, item) => (this.props.phaseType === 'Assessment' &&
    !this.filterItemSelection(options).some(o =>
      (o.label.includes(item.item_number) || o.label.includes(item.description))));

  renderPayRate = (lineItem, lpa) => ((lpa || this.props.isCustom(lineItem.item_number)) ?
    (<InputCell
      attr="price"
      label="Pay Rate"
      lineItem={lineItem}
      onChange={this.handlePriceChange}
      cellValue={formatDollars(lineItem.price)}
    />) : (<EditableTableCell
      value={formatDollars(lineItem.price)} label="Pay Rate"
    >{formatDollars(lineItem.price)}</EditableTableCell>));

  renderNote = (lineItem, isEditable) => {
    const errors = {};
    let val;
    if (this.props.isCustom(lineItem.item_number) && isEditable &&
        (lineItem.note == null || lineItem.note === '')) {
      errors.note = ['Required'];
      val = (<ItemNote
        errors={errors}
        display label="Note"
        onChange={this.handleNoteChange}
        note={lineItem.note}
        id={lineItem.id}
        kind="contractorLineItem"
      />);
    } else {
      val = (<ItemNote
        display label="Note"
        onChange={this.handleNoteChange}
        note={lineItem.note}
        id={lineItem.id}
        kind="contractorLineItem"
      />);
    }
    return (val);
  }

  renderItem = (lineItem, isEditable, lineItemOptions, lpa) => {
    let val;
    if ((lpa && !this.blockItemCellEdit(lineItemOptions, lineItem))
        || lineItem.id < 0) {
      val = (<DropDownCell
        attr="line_item_id"
        label="Item Number - Description"
        display={isEditable}
        lineItem={lineItem}
        options={this.filterItemSelection(lineItemOptions)}
        onChange={this.handleDescriptionChange}
      />);
    } else {
      val = (<EditableTableCell
        value={lineItem.item_number}
        display={isEditable}
        label="Item Number - Description"
      >{lineItem.item_number} - {lineItem.description}
      </EditableTableCell>);
    }
    return val;
  }

  handlePriceChange = this.handleChange('price');
  handleQuantityChange = this.handleChange('quantity');
  handleTotalChange = this.handleChange('total');
  handleNoteChange = this.handleChange('note');

  renderTableDesktop = () => {
    const lineItem = this.state;
    const { lineItemOptions, lpa, role, isApproved, canViewTotal } = this.props;
    const { isEditable } = this.context;
    const rowProps = {
      isNew: lineItem.id < 0, onSave: this.handleSave, onDelete: this.handleDelete,
    };
    const totalValue = formatDollars(lineItem.total);
    const hideDelete = isApproved && role !== 'admin';
    return (<EditableTableRow
      key={lineItem.id} id={lineItem.id} hideDelete={hideDelete} {...rowProps}
    >
      <ItemEvents
        display={!this.context.isEditable}
        label=""
        itemType="contractorLineItems"
        lineItem={lineItem}
        dataKeys={['item_number', 'description', 'quantity', 'price', 'note']}
      />
      <EditableTableCell display={!isEditable} value={lineItem.item_number} label="Item Number" />
      <EditableTableCell display={!isEditable} value={lineItem.description} label="Description" />
      {this.renderItem(lineItem, isEditable, lineItemOptions, lpa)}
      <InputCell
        attr="quantity"
        label="QTY"
        lineItem={lineItem}
        onChange={this.handleQuantityChange}
      />
      {canViewTotal && this.renderPayRate(lineItem, lpa)}
      {canViewTotal && <EditableTableCell value={totalValue} label="Total">
        {totalValue}
      </EditableTableCell>}
      {this.renderNote(lineItem, isEditable)}
    </EditableTableRow>);
  }

  renderTableMobile = () => {
    const lineItem = this.state;
    const { lineItemOptions, lpa, role, isApproved, canViewTotal } = this.props;
    const { isEditable } = this.context;
    const rowProps =
      { isNew: lineItem.id < 0, onSave: this.handleSave, onDelete: this.handleDelete };
    const totalValue = formatDollars(lineItem.total);
    const hideDelete = isApproved && role !== 'admin';
    return (<EditableTableRow
      key={lineItem.id} id={lineItem.id} hideDelete={hideDelete} {...rowProps}
    >
      <EditableTableCell display={!isEditable} value={lineItem.item_number} label="Item Number" />
      <EditableTableCell display={!isEditable} value={lineItem.description} label="Description" />
      {this.renderItem(lineItem, isEditable, lineItemOptions, lpa)}
      <InputCell
        attr="quantity"
        label="QTY"
        lineItem={lineItem}
        onChange={this.handleQuantityChange}
      />
      {canViewTotal && this.renderPayRate(lineItem, lpa)}
      {canViewTotal && <EditableTableCell value={totalValue} label="Total">
        {totalValue}
      </EditableTableCell>}
      {this.renderNote(lineItem, isEditable)}
      <td>
        <div>
          <table className={S.inlineTableItem}>
            <tbody className={S.inlineTableItem}>
              <tr className={S.iconWrapper}>
                <ItemEvents
                  display={!this.context.isEditable}
                  label=""
                  itemType="contractorLineItems"
                  lineItem={lineItem}
                  dataKeys={['item_number', 'description', 'quantity', 'price', 'note']}
                />
              </tr>
            </tbody>
          </table>
        </div>
      </td>
    </EditableTableRow>);
  }

  render = () => (<MediaQuery minWidth={CUT_POINT}>
    {matches => (matches ? this.renderTableDesktop() : this.renderTableMobile())}
  </MediaQuery>);
}

ContractorLaborRow.contextTypes = {
  isEditable: PropTypes.bool, surfaceType: '', filterLineItems: false,
};

ContractorLaborRow.propTypes = {
  lineItem: ContractorLineItemShape,
  onSave: PropTypes.func,
  onDelete: PropTypes.func,
  lineItemOptions: PropTypes.array,
  lpa: PropTypes.bool,
  isCustom: PropTypes.func,
  role: PropTypes.string,
  isApproved: PropTypes.bool,
  canViewTotal: PropTypes.bool,
  phaseType: PropTypes.string,
  surfaceType: PropTypes.string,
  filterLineItems: PropTypes.bool,
  phaseSource: PropTypes.string,
};

ContractorLaborRow.defaultProps = { lineItem: {}, lineItemOptions: [] };

export default ContractorLaborRow;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAccounting/components/contractorLaborRow.jsx